<template>
  <v-layout class="d-flex flex-wrap step_four">
    <v-flex>
      <v-flex class="d-flex justify-center full_width mb-4">
        <div
          ref="poster"
          class="poster"
        >
          <div class="frames" v-show="orientation">
            <v-img v-if="changeFrame === 'natur-frame'" src="assets/frames/natur.png" alt="frame"></v-img>
            <v-img v-if="changeFrame === 'black-frame'" src="assets/frames/black.png" alt="frame"></v-img>
            <v-img v-if="changeFrame === 'white-frame'" src="assets/frames/white.png" alt="frame"></v-img>
          </div>

          <div class="frames-horizontal" v-show="!orientation">
            <v-img v-if="changeFrame === 'natur-frame'" src="assets/frames/natur_horizontal.png" alt="frame"></v-img>
            <v-img v-if="changeFrame === 'black-frame'" src="assets/frames/black_horizontal.png" alt="frame"></v-img>
            <v-img v-if="changeFrame === 'white-frame'" src="assets/frames/white_horizontal.png" alt="frame"></v-img>

          </div>

          <div ref="canvas_body" class="canvas_for_image">
            <canvas id="canvasForImage"></canvas>
          </div>
          <canvas id="canvas"></canvas>
        </div>
      </v-flex>

      <v-flex class="d-flex justify-center full_width mb-4">
        <v-btn
          class="primary_button button_reset_position"
          @click="onResetPosition"
        >
          {{ $t('step-four.reset') }}
        </v-btn>
      </v-flex>
    </v-flex>

    <v-flex :class="isDesktop ? 'sidebar' : 'full_width'">
      <v-form ref="form">
        <v-flex class="d-flex justify-start full_width title">
          <p class="mb-2">{{ $t('step-four.design') }}</p>
        </v-flex>

        <v-flex class="d-flex flex-nowrap justify-start full_width title mb-4">
          <v-btn-toggle
            class="background_none z_index_up"
            v-model="designButtons"
          >
            <v-btn
              class="primary_button background_button"
              active-class="active"
              value="rectangle"
            >
              {{ $t('step-four.rectangle') }}
            </v-btn>

            <v-btn
              class="primary_button background_button"
              active-class="active"
              value="circle"
            >
              {{ $t('step-four.circle') }}
            </v-btn>

            <v-btn
              class="primary_button background_button"
              active-class="active"
              value="blob"
            >
              {{ $t('step-four.blob') }}
            </v-btn>
          </v-btn-toggle>
        </v-flex>

        <v-flex class="d-flex justify-start full_width title">
          <p class="mb-2">{{ $t('step-four.color') }}</p>
        </v-flex>

        <v-flex class="d-flex flex-nowrap justify-start full_width title mb-4">
          <v-btn-toggle
            class="background_none z_index_up"
            v-model="colorButtons"
            mandatory
          >
            <v-btn
              v-for="item in colors"
              :key="item.background"
              class="color_button"
              active-class="active"
              :color="item.background"
              @click="changeColor"
            />
          </v-btn-toggle>
        </v-flex>

        <v-flex class="d-flex justify-start full_width title">
            <p class="mb-2">{{ $t('step-four.title-orientation') }}</p>
        </v-flex>

        <v-flex
            class="d-flex full_width title"
            :class="!nextDisabled ? 'mb-4' : 'mb-0'"
        >
          <v-radio-group
              v-model="orientation"
              class="mt-0"
              row
              hide-details
          >
            <v-radio
                :label="$t('step-four.portrait')"
                color="#e17d63"
                :value="true"
            ></v-radio>
            <v-radio
                :label="$t('step-four.landscape')"
                color="#e17d63"
                :value="false"
            ></v-radio>
          </v-radio-group>
        </v-flex>

        <v-flex class="d-flex justify-start full_width title">
          <p class="mb-2">{{ $t('step-four.title') }}</p>
        </v-flex>

        <v-flex
          class="d-flex full_width title"
          :class="!nextDisabled ? 'mb-4' : 'mb-0'"
        >
          <v-text-field
            class="title_input z_index_up"
            v-model="titleText"
            :placeholder="$t('step-four.title-label')"
            @input="changeTitle"
            :rules="titleRules"
            :hide-details="!nextDisabled"
            solo
          ></v-text-field>
        </v-flex>

        <v-flex class="d-flex justify-start full_width title">
          <p class="mb-2">{{ $t('step-four.artist-name') }}</p>
        </v-flex>

        <v-flex
          class="d-flex full_width"
          :class="!nextDisabled ? 'mb-4' : 'mb-0'"
        >
          <v-text-field
            class="title_input z_index_up"
            v-model="authorText"
            :placeholder="$t('step-four.artist-name-label')"
            @input="changeAuthor"
            :rules="authorRules"
            :hide-details="!nextDisabled"
            solo
          ></v-text-field>
        </v-flex>

        <v-flex class="d-flex justify-start full_width title">
          <p class="mb-2">{{ $t('step-four.poster-size-title') }}</p>
        </v-flex>

        <v-flex class="d-flex full_width mb-4">
          <v-select
            class="title_input z_index_up"
            v-model="changePosterSize"
            :items="posterSizes"
            :item-text="item => posterName(item)"
            return-object
            hide-details
            solo
          >
            <template slot="selection" slot-scope="data">
              {{ $t('step-four.poster-size.' + data.item.name) + ' (' }}
              <span style='text-decoration: line-through;'>
                {{ posterSizePrice[data.item.name + '-past'] + '€' }}
              </span>&nbsp;
              {{ posterSizePrice[data.item.name + '-new'] + '€)' }}
            </template>
            <template v-slot:item="data">
              <v-list-item-content class="d-block">
                {{ $t('step-four.poster-size.' + data.item.name) + ' (' }}
                <span style='text-decoration: line-through;'>
                  {{ posterSizePrice[data.item.name + '-past'] + '€' }}
                </span>
                {{ posterSizePrice[data.item.name + '-new'] + '€)' }}
              </v-list-item-content>
            </template>
          </v-select>
        </v-flex>

        <v-flex class="d-flex justify-start full_width title">
          <p class="mb-2">{{ $t('step-four.frame-title') }}</p>
        </v-flex>

        <v-flex class="d-flex full_width mb-4">
          <v-select
            class="title_input z_index_up"
            :items="frames"
            v-model="changeFrame"
            hide-details
            solo
          >
            <template slot="selection" slot-scope="data">
              <slot>{{ updateFrameName(data.item) }}</slot>
            </template>
            <template v-slot:item="data">
              <v-list-item-content>{{ updateFrameName(data.item) }}</v-list-item-content>
            </template>
          </v-select>
        </v-flex>
      </v-form>
    </v-flex>

    <div
      v-if="isMobile && queryHash"
    >
      <h6 class="hash_text">
        {{ $t('step-four.hash-text.text') }}
        <a :href="linkToStart">{{ $t('step-four.hash-text.hear') }}</a>
        {{ $t('step-four.hash-text.it') }}.
      </h6>
    </div>
    <v-flex v-if="isMobile" class="d-flex justify-center full_width">
      <div class="d-flex flex-nowrap justify-space-between mb-4">
        <v-btn
          class="primary_button button_back mr-1 z_index_up"
          @click="onBackStep"
          :disabled="!!queryHash"
        >
          {{ $t('buttons.back') }}
        </v-btn>
        <v-btn
          class="primary_button ml-1 z_index_up"
          @click="onBuy"
          :disabled="nextDisabled"
        >
          {{ $t('step-four.shopping-button') }}
        </v-btn>
      </div>
    </v-flex>

    <loading-modal ref="LoadingModal"/>
  </v-layout>
</template>

<script>
import {fabric} from "fabric";
import ColorService from "@/services/ColorService";
import PosterSizeService from "@/services/PosterSizeService";
import PosterService from "@/services/PosterService";
import StoreService from "@/services/StoreService";
import LoadingModal from "@/components/home/loading-modal";
import FileService from "@/services/FileService";

const POSTER_WIDTH_HORIZONTAL = 306
const POSTER_HEIGHT_HORIZONTAL = 218
const POSTER_WIDTH_VERTICAL = 218
const POSTER_HEIGHT_VERTICAL = 306
const BACKGROUND_POSITION_MARGIN = 20
const WIDTH_BACKGROUND_COEFFICIENT = 5
const WIDTH_BACKGROUND_HORIZONTAL_CIRCLE_COEFFICIENT = 2
const SIZE_IMAGE_COEFFICIENT = 3
const ROTATE_PATH = 'assets/icons/step-four/rotate.svg'
const DRAG_PATH = 'assets/icons/step-four/icon-drag-handle.svg'
const RECTANGLE_PATH = 'assets/rectangle_poster.svg'
const RECTANGLE_HORIZONTAL_PATH = 'assets/rectangle_poster_horizontal.svg'
const CIRCLE_PATH = 'assets/circle_poster.svg'
const BLOB_PATH = 'assets/blob_poster.svg'
const BLOB_HORIZONTAL_PATH = 'assets/blob_poster_horizontal.svg'
const APP_A4_FRAME_PRICE = process.env.VUE_APP_A4_FRAME_PRICE
const APP_A3_FRAME_PRICE = process.env.VUE_APP_A3_FRAME_PRICE
const APP_50_70_FRAME_PRICE = process.env.VUE_APP_50_70_FRAME_PRICE
const FRAMES = [
  'no-frame',
  'black-frame',
  'natur-frame',
  'white-frame',
]
const POSTER_SIZE_PRICE = {
  "A4-past": process.env.VUE_APP_A4_STRIKEOUT_PRICE,
  "A4-new": process.env.VUE_APP_A4_PRICE,
  "A3-past": process.env.VUE_APP_A3_STRIKEOUT_PRICE,
  "A3-new": process.env.VUE_APP_A3_PRICE,
  "50x70-past": process.env.VUE_APP_50x70_STRIKEOUT_PRICE,
  "50x70-new": process.env.VUE_APP_50x70_PRICE
}

export default {
  name: "StepFourComponent",
  mixins: [ColorService, PosterSizeService, PosterService, StoreService, FileService],
  components: {
    'loading-modal': LoadingModal
  },
  props: {
    fabricImageId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      canvas: null,
      canvasForImage: null,
      designButtons: 'rectangle',
      colorButtons: 0,
      backgroundPositionMargin: BACKGROUND_POSITION_MARGIN,
      widthBackgroundCoefficient: WIDTH_BACKGROUND_COEFFICIENT,
      widthBackgroundHorizontalCircleCoefficient: WIDTH_BACKGROUND_HORIZONTAL_CIRCLE_COEFFICIENT,
      sizeImageCoefficient: SIZE_IMAGE_COEFFICIENT,
      colors: [],
      xmlImage: '',
      queryHash: null,
      img: null,
      titleText: '',
      authorText: '',
      background: null,
      orientation: true,
      hashFirst: false,
      changePosterSize: {},
      changeFrame: 'no-frame',
      frames: FRAMES,
      posterSizes: [],
      rotatePath: ROTATE_PATH,
      dragPath: DRAG_PATH,
      circlePath: CIRCLE_PATH,
      posterSizePrice: POSTER_SIZE_PRICE,
      appA4FramePrice: APP_A4_FRAME_PRICE,
      appA3FramePrice: APP_A3_FRAME_PRICE,
      app50x70FramePrice: APP_50_70_FRAME_PRICE,
      posterId: null,
      posterTitle: null,
      posterAuthor: null,
      titleRule: true,
      timer: null,
      timer2: null,
      timer3: null,
      timer4: null,
      readyToSave: false,
      imageScaleX: false,
      imageScaleY: false,
      imageTopMargin: false,
      imageLeftMargin: false,
      imageAngle: false,
      nextDisabled: true,
    }
  },
  computed: {
    titleRules() {
      return [
        v => !!v || this.$t('step-four.text-is-required'),
        v => v.length < 25 || this.$t('step-four.text-to-long'),
      ]
    },
    authorRules() {
      return [
        v => !!v || this.$t('step-four.text-is-required'),
        v => v.length < 55 || this.$t('step-four.text-to-long'),
      ]
    },
    rectanglePath() {
      return this.orientation ? RECTANGLE_PATH : RECTANGLE_HORIZONTAL_PATH
    },
    blobPath() {
      return this.orientation ? BLOB_PATH : BLOB_HORIZONTAL_PATH
    },
    canvasWidth() {
      return this.orientation ? POSTER_WIDTH_VERTICAL : POSTER_WIDTH_HORIZONTAL
    },
    canvasHeight() {
      return this.orientation ? POSTER_HEIGHT_VERTICAL : POSTER_HEIGHT_HORIZONTAL
    },
    linkToStart() {
      return process.env.VUE_APP_LINK_TO_START ? process.env.VUE_APP_LINK_TO_START : '#'
    }
  },
  async mounted() {
    this.imageTopMargin = false
    this.imageLeftMargin = false
    this.imageAngle = false
    this.imageScaleX = false
    this.imageScaleY = false
    this.nextDisabled = false
    this.readyToSave = false
    this.posterId = null
    this.changeRotateIconOnFabric()
    this.initMovementImage()
    await this.setColors()
    await this.setPosterSizes()
    await this.canvasInit()
    if (this.$route.query.hash) {
      this.designButtons = null
      this.$emit('isDisabledBack')
      this.queryHash = this.$route.query.hash
      this.awaitSetPosterData()
    } else {
      this.awaitPictureInit()
      this.awaitInitBackground()
    }
    this.posterTitleInit()
    this.posterAuthorInit()
  },
  methods: {
    changeRotateIconOnFabric() {
      fetch(this.rotatePath)
        .then(response => response.text())
        .then(svgCode => {
          const svgRotateIcon = encodeURIComponent(svgCode);
          const rotateIcon = `data:image/svg+xml;utf8,${svgRotateIcon}`;

          const imgIcon = document.createElement('img');
          imgIcon.src = rotateIcon;

          fabric.Object.prototype.controls.mtr = new fabric.Control({
            x: 0,
            y: -0.5,
            offsetX: 0,
            offsetY: -40,
            cursorStyle: 'crosshair',
            actionHandler: fabric.controlsUtils.rotationWithSnapping,
            actionName: 'rotate',
            render: function (ctx, left, top, styleOverride, fabricObject) {
              var size = 30;
              ctx.save();
              ctx.translate(left, top);
              ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
              ctx.drawImage(imgIcon, -size / 2, -size / 2, size, size);
              ctx.restore();
            },
            cornerSize: 38,
            withConnection: true
          });
        })
    },
    initMovementImage() {
      fetch(this.dragPath)
        .then(response => response.text())
        .then(svgCode => {
          const svgRotateIcon = encodeURIComponent(svgCode);
          const dragIcon = `data:image/svg+xml;utf8,${svgRotateIcon}`;

          const imgIcon = document.createElement('img');
          imgIcon.src = dragIcon;

          fabric.Object.prototype.controls.mt = new fabric.Control({
            x: 0,
            y: 0,
            offsetX: 0,
            offsetY: 0,
            cursorStyle: 'crosshair',
            actionHandler: fabric.controlsUtils.dragHandler,
            actionName: 'drag',
            render: function (ctx, left, top, styleOverride, fabricObject) {
              var size = 30;
              ctx.save();
              ctx.translate(left, top);
              ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
              ctx.drawImage(imgIcon, -size / 2, -size / 2, size, size);
              ctx.restore();
            },
            cornerSize: 38,
            withConnection: true
          });
        })
    },
    awaitSetPosterData() {
      clearTimeout(this.timer4)
      if (this.posterSizes.length > 0 && this.colors.length > 0) {
        this.setPosterData()
        return
      }

      this.timer4 = setTimeout(() => {
        this.awaitSetPosterData()
      }, 20)
    },
    setPosterData() {
      const params = {
        hash: this.queryHash
      }
      this.getPoster(params)
        .then((response) => {
          const result = response.data.data
          this.posterId = result.id
          this.hashFirst = result.is_vertical != 1
          this.$emit('setFabricImageId', result.picture_svg_id)
          this.designButtons = result.design
          this.changeFrame = result.frame
          this.titleText = result.title
          this.authorText = result.name
          this.changeTitle(result.title)
          this.changeAuthor(result.name)
          this.changePosterSize = this.posterSizes.find(item => item.id == result.poster_size_id)
          this.colorButtons = this.colors.findIndex(item => item.id == result.color_id)
          this.imageScaleX = result.scaleX
          this.orientation = result.is_vertical == 1
          this.imageScaleY = result.scaleY
          this.imageTopMargin = +result.position_top + this.topImageMargin();
          this.imageLeftMargin = +result.position_left + this.leftImageMargin();
          this.imageAngle = result.angle;
          this.awaitPictureInit()
        })
        .catch((err) => {
          this.$emit('backToStep1')
          console.log('error', err)
          this.onCallToastr('error', 'Something went wrong, please try again later', 'Failed!')
        })
    },
    awaitPictureInit() {
      clearTimeout(this.timer)
      if (!this.fabricImageId) {
        this.timer = setTimeout(() => {
          this.awaitPictureInit()
        }, 20)
        return
      }
      this.pictureInit()
    },
    awaitInitBackground() {
      clearTimeout(this.timer2)
      if (this.colors.length) {
        this.changeBackground()
        return
      }
      this.timer2 = setTimeout(() => {
        this.awaitInitBackground()
      }, 20)
    },
    awaitFabricPictureInit() {
      clearTimeout(this.timer)
      if (!this.xmlImage || this.colors.length < 1) {
        this.timer = setTimeout(() => {
          this.awaitFabricPictureInit()
        }, 20)
        return
      }
      this.fabricPictureInit()
    },
    setColors() {
      this.getColors()
        .then((response) => {
          this.colors = response.data
        })
        .catch((err) => {
          console.log('error', err)
          this.onCallToastr('error', 'Something went wrong, please try again later', 'Failed!')
        })
    },
    setPosterSizes() {
      this.getPosterSizes()
        .then((response) => {
          this.posterSizes = response.data
          if (this.posterSizes.length && !this.queryHash) {
            this.changePosterSize = this.posterSizes[0]
          }
        })
        .catch((err) => {
          console.log('error', err)
          this.onCallToastr('error', 'Something went wrong, please try again later', 'Failed!')
        })
    },
    canvasInit() {
      this.canvas = new fabric.Canvas('canvas');
      this.canvas.backgroundColor = "white";
      this.canvas.setWidth(this.canvasWidth);
      this.canvas.setHeight(this.canvasHeight);
      this.canvasForImage = new fabric.Canvas('canvasForImage', {
        selection: false,
      });
      this.canvasForImage.setWidth(this.canvasWidth);
      this.canvasForImage.setHeight(this.canvasHeight);
    },
    posterTitleInit() {
      this.posterTitle = new fabric.Textbox('', {
          selectable: false,
          absolutePositioned: true,
          fontFamily: 'gotham',
          fontSize: 9,
          top: this.canvasHeight - 35,
          left: (this.canvasWidth - 200) / 2,
          width: 200,
          textAlign: 'center',
          bottom: 10,
          fontWeight: "bold"
        }
      );
      this.canvas.add(this.posterTitle);
    },
    onResetPosition() {
      this.canvasForImage.remove(this.img);
      this.pictureInit()
    },
    changeTitle(text) {
      this.nextDisabled = false
      this.$emit('onDisabled', this.nextDisabled)
      if (text.length > 24) {
        this.nextDisabled = true
        this.$emit('onDisabled', this.nextDisabled)
        return false;
      }
      this.posterTitle.set('text', text.toUpperCase())
      this.canvas.requestRenderAll();
    },
    posterAuthorInit() {
      this.posterAuthor = new fabric.Textbox('', {
          selectable: false,
          absolutePositioned: true,
          fontFamily: 'gotham',
          fontSize: 5,
          top: this.canvasHeight - 22,
          left: (this.canvasWidth - 200) / 2,
          width: 200,
          textAlign: 'center',
          bottom: 10
        }
      );
      this.canvas.add(this.posterAuthor);
    },
    changeAuthor(text) {
      this.nextDisabled = false
      this.$emit('onDisabled', this.nextDisabled)
      if (text.length > 40) {
        this.nextDisabled = true
        this.$emit('onDisabled', this.nextDisabled)
        return false;
      }
      this.posterAuthor.set('text', text)
      this.canvas.requestRenderAll();
    },
    getSvgImage() {
      const param = {
        id: this.fabricImageId
      }
      this.getSvgQuery(param)
        .then((response) => {
          this.xmlImage = response.data
        })
        .catch((err) => {
          console.log('error', err)
          this.onCallToastr('error', 'Something went wrong, please try again later', 'Failed!')
        })
    },
    changeSvgImageColor() {
      const parser = new DOMParser();
      const svgDoc = parser.parseFromString(this.xmlImage, 'image/svg+xml');
      let svg = svgDoc.querySelector('svg');
      if (svg) {
        for (let g of svg.querySelectorAll('g')) {
          g.setAttribute('fill', this.colors[this.colorButtons].color)
        }
      }

      const newSvg = (new XMLSerializer()).serializeToString(svgDoc);
      const blob = new Blob([newSvg], {type: "image/svg+xml"});
      return URL.createObjectURL(blob);
    },
    fabricPictureInit(savePoster = false) {

      fabric.loadSVGFromURL(this.changeSvgImageColor(), (objects, options) => {
        let image = fabric.util.groupSVGElements(objects, options);
        image._setOriginToCenter();

        image.scale(1.0).set({
          top: this.imageTopMargin !== false ? +this.imageTopMargin : this.topImageMargin(),
          left: this.imageLeftMargin !== false ? +this.imageLeftMargin : this.leftImageMargin(),
          angle: this.imageAngle !== false ? +this.imageAngle : 0,
          cornerStyle: "circle",
          cornerFill: '#c59a9a',
          cornerStrokeColor: '#c59a9a',
          cornerSize: 25,
          cornerColor: "rgba(197, 154, 154, 0.2)",
          transparentCorners: true,
          minScaleLimit: 0.025,

          borderScaleFactor: 1.5,
          borderDashArray: [4],
          borderColor: '#c59a9a',
          fill: this.colors[this.colorButtons].background
        });
        //set image size
        if (this.imageScaleX !== false && this.imageScaleY !== false) {
          image.scale(1.0).set({
            scaleX: this.imageScaleX,
            scaleY: this.imageScaleY,
          })
        } else {
          if (image.height > image.width) {
            image.scaleToHeight(this.imageHeight())
          } else {
            image.scaleToWidth(this.imageWidth())
          }
        }

        if (savePoster) {
          this.canvas.add(image).renderAll();
          this.readyToSave = true
        } else {
          this.canvasForImage.add(image)
          this.canvasForImage.discardActiveObject();
          this.canvasForImage.setActiveObject(image);
          this.canvasForImage.requestRenderAll();
          this.initMovementImage()
          this.img = image
        }
      })
    },
    async pictureInit() {
      await this.getSvgImage()
      this.awaitFabricPictureInit()
    },
    setFabricBackground(imagePath, isCircle = false, isHorizontal = false) {
      fabric.loadSVGFromURL(imagePath, (objects, options) => {
        this.background = fabric.util.groupSVGElements(objects, options);
        const widthCoefficient = isCircle && isHorizontal
            ? this.widthBackgroundHorizontalCircleCoefficient
            : isHorizontal ? 6 : this.widthBackgroundCoefficient;
        this.background.scale(1.0).set({
          top: isCircle && !isHorizontal ? this.backgroundPositionMargin * 2 : this.backgroundPositionMargin,
          left: this.canvasWidth / (widthCoefficient * 2),
          selectable: false,
          fill: this.colors[this.colorButtons].background
        });
        this.background.scaleToWidth(this.getBackgroundWidth(widthCoefficient));
        this.canvas.add(this.background).sendToBack(this.background).renderAll();
      })
    },
    changeBackground() {
      if (this.background) this.canvas.remove(this.background);
      if (this.designButtons === 'rectangle') {
        this.setFabricBackground(this.rectanglePath, false, !this.orientation)
      } else if (this.designButtons === 'circle') {
        this.setFabricBackground(this.circlePath, true, !this.orientation)
      } else if (this.designButtons === 'blob') {
        this.setFabricBackground(this.blobPath)
      }
    },
    changeColor() {
      this.$nextTick(() => {
        this.changeImageColor()
        this.changeBackground()
      })
    },
    changeImageColor(top = false, left = false, angle = false, savePoster = false) {
      this.imageTopMargin = top ? top : this.img.top
      this.imageLeftMargin = left ? left : this.img.left
      this.imageAngle = angle ? angle : this.img.angle
      this.imageScaleX = this.img.scaleX
      this.imageScaleY = this.img.scaleY
      if (this.img) this.canvasForImage.remove(this.img);
      this.fabricPictureInit(savePoster)
    },
    topImageMargin() {
      return this.canvasHeight / 2 - this.backgroundPositionMargin / 2
    },
    leftImageMargin() {
      return this.canvasWidth / 2
    },
    getBackgroundWidth(widthCoefficient) {
      return this.canvasWidth - (this.canvasWidth / widthCoefficient)
    },
    imageWidth() {
      return this.canvasWidth - (this.canvasWidth / this.sizeImageCoefficient)
    },
    imageHeight() {
      return this.canvasHeight - (this.canvasHeight / this.sizeImageCoefficient)
    },
    updateFrameName(frameName) {
      if (frameName === 'no-frame' ) return this.$t('step-four.frame.' + frameName)
      if (this.changePosterSize.name === 'A4') return this.$t('step-four.frame.' + frameName) + ' (+' + this.appA4FramePrice + '€)'
      if (this.changePosterSize.name === 'A3') return this.$t('step-four.frame.' + frameName) + ' (+' + this.appA3FramePrice + '€)'
      if (this.changePosterSize.name === '50x70') return this.$t('step-four.frame.' + frameName) + ' (+' + this.app50x70FramePrice + '€)'
      return this.$t('step-four.frame.' + frameName)
    },
    posterName(item) {
      return this.$t('step-four.poster-size.' + item.name) + ' ' + this.$t('step-four.poster-size-cost.' + item.name)
    },
    onBackStep() {
      this.$emit('onBackStep')
    },
    joinCanvases() {
      const top = this.img.top
      const left = this.img.left
      this.changeImageColor(top, left, this.img.angle, true)
    },
    awaitSavePoster() {
      clearTimeout(this.timer3)
      if (!this.readyToSave) {
        this.timer3 = setTimeout(() => {
          this.awaitSavePoster()
        }, 20)
        return
      }

      const blob = new Blob([this.canvas.toSVG()], {type: "image/svg+xml"});

      let payload = new FormData
      payload.append('design', this.designButtons)
      payload.append('color_id', this.colors[this.colorButtons].id)
      payload.append('title', this.titleText)
      payload.append('name', this.authorText)
      payload.append('is_vertical', this.orientation ? 1 : 0)
      payload.append('poster_size_id', this.changePosterSize.id)
      payload.append('picture_svg_id', this.fabricImageId)
      payload.append('frame', this.changeFrame)
      payload.append('scaleX', this.img.scaleX)
      payload.append('scaleY', this.img.scaleY)
      payload.append('angle', Math.round(this.img.angle))
      payload.append('position_top', Math.round(this.img.top - this.topImageMargin()))
      payload.append('position_left', Math.round(this.img.left - this.leftImageMargin()))
      payload.append('file', blob, 'poster.svg')

      if (this.$route.query.hash) {
        this.updatePoster(this.posterId, payload)
          .then(response => {
            if (!(response.data || response.data.hash)) return;
            this.onSendToCard(response)
          })
          .catch((err) => {
            this.$refs.LoadingModal.isModalOpen = false
            console.log('error', err)
            this.onCallToastr('error', 'Something went wrong, please try again later', 'Failed!')
          })
      } else {
        this.savePoster(payload)
          .then(response => {
            if (!(response.data || response.data.hash)) return;
            this.onSendToCard(response)
          })
          .catch((err) => {
            this.$refs.LoadingModal.isModalOpen = false
            console.log('error', err)
            this.onCallToastr('error', 'Something went wrong, please try again later', 'Failed!')
          })
      }
    },
    onSendToCard(response) {
      const size = this.changePosterSize.name.replace('x', '')
      parent.postMessage(
        JSON.stringify({
          event: 'addToCart',
          hash: response.data.hash,
          size: size,
          frame: this.changeFrame
        }), "https://famwalls.com/");
    },
    onBuy() {
      if (!this.$refs.form.validate()) {
        this.nextDisabled = true
        this.$emit('onDisabled', this.nextDisabled)
        return
      }
      this.$refs.LoadingModal.isModalOpen = true
      this.readyToSave = false
      this.joinCanvases();
      this.awaitSavePoster()
    }
  },
  watch: {
    designButtons: function () {
      this.changeBackground()
    },
    orientation: async function (value) {
      const $canvasForImage = this.$refs.canvas_body
      const $poster = this.$refs.poster
      this.canvasForImage.remove(this.img);
      if (this.background) this.canvas.remove(this.background);
      this.canvas.remove(this.posterTitle);
      this.canvas.remove(this.posterAuthor);
      this.imageTopMargin = false
      this.imageLeftMargin = false
      this.imageAngle = false
      this.imageScaleX = false
      this.imageScaleY = false
      if (value) {
        $canvasForImage.style.width = POSTER_WIDTH_VERTICAL + "px"
        $canvasForImage.style.height = POSTER_HEIGHT_VERTICAL + 'px'
        $poster.style.width = POSTER_WIDTH_VERTICAL + 'px'
        $poster.style.height = POSTER_HEIGHT_VERTICAL + 'px'
        this.canvas.setWidth(POSTER_WIDTH_VERTICAL);
        this.canvas.setHeight(POSTER_HEIGHT_VERTICAL);
        this.canvasForImage.setWidth(POSTER_WIDTH_VERTICAL);
        this.canvasForImage.setHeight(POSTER_HEIGHT_VERTICAL);
      } else {
        $canvasForImage.style.width = POSTER_WIDTH_HORIZONTAL + 'px'
        $canvasForImage.style.height = POSTER_HEIGHT_HORIZONTAL + 'px'
        $poster.style.width = POSTER_WIDTH_HORIZONTAL + 'px'
        $poster.style.height = POSTER_HEIGHT_HORIZONTAL + 'px'
        this.canvas.setWidth(POSTER_WIDTH_HORIZONTAL);
        this.canvas.setHeight(POSTER_HEIGHT_HORIZONTAL);
        this.canvasForImage.setWidth(POSTER_WIDTH_HORIZONTAL);
        this.canvasForImage.setHeight(POSTER_HEIGHT_HORIZONTAL);
      }

      await this.setPosterSizes()
      if (!this.hashFirst) {
        this.awaitPictureInit()
        this.awaitInitBackground()
      } else {
        this.hashFirst = false
      }

      this.posterTitleInit()
      this.posterAuthorInit()
      this.changeTitle(this.titleText)
      this.changeAuthor(this.authorText)

    }
  }
};
</script>
